import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const bonuses = [{
  tag: '🎁 Bonus #1',
  emoji: '🎥',
  title: 'CARDBOARD ARCADE PACK',
  text: 'Eine unterhaltsame Videosammlung, die Schritt für Schritt zeigt, wie man interaktive Spiele baut — wie einen Mini-Spaceball-Tisch, individuelle Glücksräder und Arcade-Automaten aus einfachem Karton und ganz viel Fantasie.',
  img: 'https://cdn.magicpatterns.com/uploads/rm6gShtDYvYzPFcSoGNy2X/IMG_1071.webp',
  price: '25,00 €'
}, {
  tag: '🎁 Bonus #2',
  emoji: '✂️',
  title: 'DER 5-MINUTEN-PAPERCRAFT-GUIDE',
  text: 'Dein Nachschlagewerk für schnelle, saubere Papier- und Kartonbasteleien. Perfekt für Nachmittage, an denen du kein besonderes Material hast, aber eine einfache Aktivität brauchst, um sie vom Bildschirm wegzuholen.',
  img: 'https://cdn.magicpatterns.com/uploads/1CpLsWXtwqnmKgUPe3SsG4/IMG_1072.webp',
  price: '19,00 €'
}, {
  tag: '🎁 Bonus #3',
  emoji: '🌈',
  title: 'KLEINE KREATIVE: SLIME & SENSORIK',
  text: 'Ein spezieller Ratgeber voller einfacher Rezepte für selbstgemachten Slime, Knetmasse und sensorische Texturen. Ideal, um jüngere Geschwister glücklich zu beschäftigen, während sie mit ihren Händen etwas erschaffen.',
  img: 'https://cdn.magicpatterns.com/uploads/dBr1uuNNizqi2RLuGzMBx2/IMG_1073.webp',
  price: '19,00 €'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-23" data-mp="2ugr1e4j4i9oy">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-24" data-mp="2uibtlnhytgjn">
        <SectionHeading eyebrow="🎁 Exklusive Boni" title={<>Bestelle heute & erhalte diese 3 gratis Boni</>} subtitle="Wenn du dir MakerLab jetzt sicherst, schaltest du außerdem diese 3 exklusiven Boni frei — für immer dein, ohne zusätzliche Kosten." data-id="element-25" data-mp="38gim0o45aobx" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-26" data-mp="irgbd0ulel4i">
          {bonuses.map((b, i) => <motion.article key={b.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col overflow-hidden rounded-3xl border border-ink/10 bg-cream" data-id="element-27" data-mp="3cjfylch1gpix" data-mpi={i}>
              <div className="aspect-square w-full overflow-hidden border-b border-ink/10" data-id="element-28" data-mp="2xrntruevetvg">
                <img src={b.img} alt={b.title} className="h-full w-full object-cover" data-id="element-29" data-mp="32r0h0g9nm2yk" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-30" data-mp="2a3whgqtbygu6">
                <div className="mb-3 flex items-center justify-between" data-id="element-31" data-mp="2f30pvf8fkajg">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-light px-3 py-1 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-32" data-mp="2f167o8ojmwj2">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="22lg7teld87dr" />
                    {b.tag}
                  </span>
                  <span className="flex items-center gap-1.5 text-sm" data-id="element-34" data-mp="1xnwqu6xa9gi4">
                    <span className="text-ink/40 line-through" data-id="element-35" data-mp="1tjp249qts0jw">{b.price}</span>
                    <span className="font-bold text-emerald-600" data-id="element-36" data-mp="1om72xb2m0zp3">GRATIS</span>
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-37" data-mp="1jsui7c11xd1m">
                  {b.emoji} {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-38" data-mp="19wj0u7mltx0b">
                  {b.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}